import * as React from "react";
import type { SVGProps } from "react";
const SvgFolderDown02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14.026 19.712H4.774a2.4 2.4 0 0 1-2.4-2.4V5.029a1.2 1.2 0 0 1 1.2-1.2H9.29l2.765 2.954h8.317a1.2 1.2 0 0 1 1.2 1.2v3.188m.054 6.557-2.454 2.442m0 0-2.346-2.332m2.345 2.332v-6"
    />
  </svg>
);
export default SvgFolderDown02;
